let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3Q6GO")).then(() => parcelRequire('flkxC'));